<template>
<div>
    <AppNav></AppNav>
    <div class="row">
      <div class="col-lg-6"></div>
    </div>
    <div  class="row">
      <div class="col-sm-1"></div>
      <div class="col-xs-12  col-sm-8">
        <h4> Modifier les dates ou le motif du contrat d'interim.</h4>
        <p>Pour modifier les noms, faire un nouveau contrat!</p>
        <form> 
          <router-link to="/contrats_interim" class="btn btn-primary mb-3"> Retour vers la liste</router-link>
          <div class="row">
           
            <div class="col-md-6">    
                <input id="interimaire" name ="interimaire" type="text"  class="form-control" disabled   :value="contratsInterimById.interimaireByInterimaireId.nom + ' ' + contratsInterimById.interimaireByInterimaireId.prenom" />
                    
                <input name ="iade" type="text"  class="form-control" disabled :value="contratsInterimById.iadeByIadeId.nom + ' ' +
                contratsInterimById.iadeByIadeId.prenom" />
                <select  name="raison" id="raison" class="form-control" type="text" v-on:change="updateField('raison', $event.target.value)" >
                    <option :value="contratsInterimById.raison" selected data-default>{{contratsInterimById.raison}}</option>
                    <option value="congés payés">Congés payés</option>
                    <option value="maladie">Maladie</option>
                    <option value="formation">Formation</option>
                </select>
                <datetime 
                    input-class="form-control"
                    :value="contratsInterimById.dateDebut"
                    type="datetime"
                    placeholder="Date et heure de début du remplacement"
                    minute-step="30"
                    zone="local"
                    value-zone="local"
                    v-on:input="updateField('dateDebut', $event)">
                </datetime>
                <datetime 
                    input-class="form-control"
                    :value="contratsInterimById.dateFin"
                    type="datetime"
                    placeholder="Date et heure de fin du remplacement"
                    minute-step="30"
                    zone="local"
                    value-zone="local"
                    v-on:input="updateField('dateFin', $event)">
                </datetime>
                <input 
                  type="text"  
                  class="form-control" 
                  name="taux-brut" 
                  :value="contratsInterimById.tauxBrut" 
                  placeholder="Taux horaire brut (29.00 par défaut)"
                  v-on:change="updateField('tauxBrut', $event.target.value)">
                <input  type="submit" value="Valider" class="btn btn-primary btn-block" @click.prevent="editContrat" />  
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-xs-12.col-sm-4"> 
      <p class="lead">{{sidebar}}</p>
    </div>
</div>
</template>
<script>
import AppNav from '../AppNav'
import moment from 'moment'
import {
  CONTRAT_BY_ID_QUERY,
  UPDATE_CONTRAT,
  ALL_CONTRATS
} from '../../constants/contratsInterim'

  export default {
    name: 'contrat-interim-edit',
    components: {
      AppNav,
    },
    data() {
      return {
        moment: moment,
        contratsInterimById: {},
        sidebar: "",
        dateDebut: null,
        dateFin: null,
        raison: "",
        tauxBrut: null
      }
    },
    apollo: {
        contratsInterimById: {
            query: CONTRAT_BY_ID_QUERY,
            variables() {
                var id = parseInt(this.$route.params.id,10)
                return{
                    id
                }
            }
        }
    },
    methods: {
        editContrat: function () {  
          console.log(this)
            const dateDebut = this.dateDebut || this.contratsInterimById.dateDebut
            const dateFin =  this.dateFin || this.contratsInterimById.dateFin
            const raison = this.raison || this.contratsInterimById.raison
            const tauxBrut = this.tauxBrut || this.contratsInterimById.tauxBrut
            var self = this;
            this.$apollo.mutate({
          mutation: UPDATE_CONTRAT,
          variables: {
           id: this.contratsInterimById.id,
            dateDebut: dateDebut,
            dateFin: dateFin,
            raison: raison,
            tauxBrut: tauxBrut
          },
           refetchQueries: [{
              query: ALL_CONTRATS,
              variables: {
                first: 50,
                offset: 0
              }
            }]   
        }).then((data) => {
            console.log("data ",data)
            self.$router.push({name: 'ContratsInterim'})
        }).catch((error) => {
          // Error
          console.error("error",error);
          // We restore the initial user input
        })
        },    
      
        updateField( field,target){
            this[field] = target
            console.log('ft', field, target)
        }
    }
  }

</script>
<style scoped>
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}


/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}


</style>



// WEBPACK FOOTER //
// contratEdit.vue?7e61b852